<template>
  <v-app-bar flat color="white">
    <v-progress-linear
      absolute
      color="secondary"
      :active="appStore.loading"
      :indeterminate="appStore.loading"
    ></v-progress-linear>
    <v-container class="d-flex align-center justify-center justify-md-start">
      <router-link :to="{ name: 'Home' }" class="">
        <v-img
          eager
          inline
          width="175"
          src="@/assets/logo-horizontal.svg"
          class="mr-2"
        ></v-img>
      </router-link>

      <!-- <router-link
        class="nav-menu-btn"
        density="comfortable"
        :to="{ name: 'Home', hash: '#section-features-patient' }"
        v-if="smAndUp"
        >{{ $t('appBar.features') }}</router-link
      > -->
      <router-link
        class="nav-menu-btn"
        density="comfortable"
        :to="{ name: 'Mission' }"
        v-if="smAndUp"
        >{{ $t('appBar.our_mission') }}</router-link
      >

      <router-link
        class="nav-menu-btn"
        density="comfortable"
        :to="{ name: 'Home', hash: '#section-contact' }"
        v-if="smAndUp"
        >{{ $t('appBar.contact') }}</router-link
      >

      <!--<v-btn class="nav-menu-btn" density="comfortable" :to="{name: 'Home', hash: '#section-resources'}" v-if="smAndUp">
          {{ $t('appBar.resources') }}
      </v-btn>
      <v-btn class="nav-menu-btn" density="comfortable" :to="{name: 'Home', hash: '#section-faq'}" v-if="smAndUp">
          {{ $t('appBar.faq') }}
      </v-btn> -->

      <!-- <v-spacer></v-spacer>

      <v-btn class="text-primary font-weight-bold" density="comfortable" slim tile variant="plain" :to="{ name: 'Home' }">A propos</v-btn>
      <v-btn class="text-primary font-weight-bold" density="comfortable" tile slim variant="plain" :to="{ name: 'Home' }">Découvrir</v-btn>
      <v-btn class="text-primary font-weight-bold" density="comfortable" tile slim variant="plain" :to="{ name: 'Home' }">Nos Engagements</v-btn>
      <v-btn class="text-primary font-weight-bold" density="comfortable" tile slim variant="plain" :to="{ name: 'Home' }">Centre d'aide</v-btn>
      <v-btn class="text-primary font-weight-bold" density="comfortable" tile slim variant="plain" :to="{ name: 'Home' }">Autres</v-btn> -->
      <v-spacer></v-spacer>
      <template v-if="!userStore.isLogged">
        <v-primary-btn :to="{ name: 'PractitionerPresentation' }">
          <span v-if="smAndUp">
            {{ $t('appBar.areYouPractitioner') }}
          </span>
          <span v-else>
            {{ $t('appBar.practitioner') }}
          </span>
        </v-primary-btn>

        <v-secondary-btn
          v-if="smAndUp"
          :to="{ name: 'Login' }"
          prepend-icon="mdi-account-outline"
          class="ml-2"
        >
          {{ $t('appBar.login') }}
        </v-secondary-btn>
        <v-btn
          v-else
          :to="{ name: 'Login' }"
          variant="outlined"
          icon="mdi-account-outline"
          color="secondary"
          class="ml-2"
          density="comfortable"
        ></v-btn>
      </template>
      <template v-else>
        <BeCalledBack v-if="userStore.user.profilType === 'practitioner'" />
        <!--        Add a avatar icon button with a menu. Add in the menu "Dashboard" and "Logout" items -->
        <auth-menu />
      </template>
    </v-container>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { useUserStore } from '@/store/user/userStore'
import { useAppStore } from '@/store/app'
import AuthMenu from '@/components/AuthMenu.vue'
import VPrimaryBtn from '@/components/buttons/VPrimaryBtn.vue'
import VSecondaryBtn from '@/components/buttons/VSecondaryBtn.vue'
import BeCalledBack from '@/components/BeCalledBack.vue'

const { xs, smAndUp } = useDisplay()
const userStore = useUserStore()
const appStore = useAppStore()
</script>

<style scoped>
.nav-menu-btn {
  font-family: 'Poppins';
  color: #616161;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: normal;
  text-decoration: none;
  padding-inline: 10px;
}

@media screen and (max-width: 600px) {
  .nav-menu-btn {
    display: none;
  }
}

:deep(.v-toolbar__content) {
  background-color: #ffffff;
}
</style>
